import FormUtils from './form-utils';
import FormAssets from './form-assets';
import DatePicker from './date-picker';
import DropdownMenu from './dropdown';

const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * FORM.JS
 */
export default class Form {

	static init() {
		return new Form();
	}

	constructor() {
		DatePicker.init();
		DropdownMenu.init();
	
		const forms = document.querySelectorAll('form.generic-form');
		forms.forEach((form) => {
			this.initForm(form);
		});
	}

	initForm(form) {
		if (!form)
			return;

		FormAssets.init(form);
	
		const successText = form.querySelector('.success-message');
		const errorText = form.querySelector('.error-message');
		const buttonSubmit = form.querySelector('.button-submit');
		const redirectUriInput = form.querySelector('input[name="redirect_uri"]');
		let shouldRedirect = redirectUriInput && redirectUriInput.value != null;
		let loadingSpinner = buttonSubmit.querySelector('.animate-spin');
		
		form.addEventListener('submit', (event) => {
			event.preventDefault();
	
			loadingSpinner.classList.remove('hidden');
	
			axios.post(form.action, new FormData(form))
				.then(() => {
					FormUtils.hideErrorFields(form);
					errorText.classList.add('hidden');
					successText.classList.remove('hidden');
	
					if (shouldRedirect)
						window.location.href = redirectUriInput.value;
					else {
						loadingSpinner.classList.add('hidden');
						FormUtils.clearAllFields(form);
					}
				})
				.catch((error) => {
					loadingSpinner.classList.add('hidden');
					successText.classList.add('hidden');
	
					FormUtils.hideErrorFields(form);
	
					if (error.response) {
						// Request made and server responded
						if (error.response.data && error.response.data.error && error.response.status == 400)
							FormUtils.handleFormErrors(form, error.response.data.error);
						else errorText.classList.remove('hidden');
	
					} else if (error.request) {
						// The request was made but no response was received
						console.log(error.request);
						errorText.classList.remove('hidden');
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
						errorText.classList.remove('hidden');
					}
				});
		});
	}
}